import { Component } from '@angular/core';
import { CandyService } from '../../candy.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class ForgotPasswordComponent {

  email: string = null;
  isSubmitting = false;
  errorMessage: string = null;
  successMessage: string = null;

  constructor(private candy: CandyService) {}

  submit() {
    this.isSubmitting = true;
    this.errorMessage = null;
    this.successMessage = null;

    this.candy.createRequest('POST', 'api/dashboard/modules/admin-user/forgot-password', {
      email: this.email,
    }).subscribe(response => {
      this.successMessage = response['message'];
      this.isSubmitting = false;
    }, error => {
      this.errorMessage = this.extractError(error);
      this.isSubmitting = false;
    });
  }

  private extractError(error): string {
    const validationErrors = error?.error?.errors;
    if (validationErrors) {
      return validationErrors[Object.keys(validationErrors)[0]][0];
    }

    return error?.error?.message || 'Something went wrong!';
  }
}
